/* eslint-disable no-useless-computed-key */
import useSWR from "swr";
import { productDataType } from "../../../types/store-types";
import inventoryavailabilityService from "../../../_foundation/apis/transaction/inventoryavailability.service";
import { useSite } from "../../../_foundation/hooks/useSite";
import { swrOptionsNoRetry } from "./constants";

export const useAvailabilitiesInStore = (stores: number[], skus: productDataType) => {
  const { mySite } = useSite();

  const filteredSkus = skus?.filter((sku) => !sku.sku.includes("FPC")) || [];
  const products = filteredSkus.reduce((acc, sku: any) => {
    acc[sku.sku] = sku.quantity;
    return acc;
  }, {} as Record<string, number>);

  const payload = {
    widget: "useAvailabilitiesInStore",
    body: {
      ["shopIds[]"]: stores,
      products,
      productStoreId: mySite.catalogStoreID,
      includePendingOrders: window.location.pathname.includes("/produits") ? "false" : "true",
    },
  };

  const swrKey = stores?.length > 0 && Object.keys(products).length > 0 ? payload : null;
  return useSWR(swrKey, inventoryavailabilityService.getInventoryAvailability, swrOptionsNoRetry);
};
